import styled from "@emotion/styled";
import { typography } from "../../../../../themes/typography/typography.js";
import "../../../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../../../themes/typography/utils/typographyVariants/typographyVariants.js";
const LogoContainer = (theme) => ({
  display: "flex",
  alignItems: "center",
  gap: "0.5rem",
  marginBottom: "2rem",
  [theme.breakpoints.down("lg")]: {
    justifyContent: "center"
  }
});
const LogoText = (theme) => ({
  ...typography["Lato H4"],
  fontWeight: 400,
  fontSize: "24px",
  lineHeight: "32px",
  letterSpacing: "0px",
  color: theme.palette.primary.main,
  [theme.breakpoints.down("md")]: {
    ...typography["Lato Body 1"],
    fontSize: "16px",
    lineHeight: "21px"
  }
});
const Logo = styled.img`
  width: 40px;
  height: 40px;
`;
const Title = (theme) => ({
  fontSize: "36px",
  lineHeight: "48px",
  fontWeight: 400,
  letterSpacing: "0.25px",
  verticalAlign: "middle",
  marginBottom: "2rem",
  "& span": {
    color: theme.palette.primary.main
  },
  [theme.breakpoints.down("md")]: {
    ...typography["Lato H4"],
    fontSize: "24px",
    lineHeight: "32px"
  },
  [theme.breakpoints.down("sm")]: {
    display: "none"
  }
});
const Description = (theme) => ({
  ...typography["Lato Body 1"],
  fontSize: "16px",
  lineHeight: "24px",
  fontWeight: 400,
  letterSpacing: "0.25px",
  color: theme.palette.grey[700],
  marginBottom: "2rem",
  [theme.breakpoints.down("md")]: {
    lineHeight: "22px",
    paragraphSpacing: "16px"
  },
  [theme.breakpoints.down("sm")]: {
    marginBottom: "0.5rem"
  }
});
const FormContainer = () => ({
  maxWidth: "442px",
  width: "100%"
});
const StyledTextField = (theme) => ({
  ...typography["Lato Body 2"],
  color: theme.palette.grey[800],
  fontSize: "14px",
  lineHeight: "20px",
  fontWeight: 400,
  paragraphSpacing: "16px",
  letterSpacing: "0.25px",
  verticalAlign: "middle",
  marginBottom: "1.75rem",
  gap: "1rem",
  span: {
    color: theme.palette.error.main
  },
  input: {
    padding: "1rem 0.75rem"
  },
  "& .MuiFormLabel-asterisk": {
    display: "none"
  },
  "& .Mui-error": {
    "&:before": {
      borderBottom: `2px solid ${theme.palette.error[500]}`
    }
  },
  [theme.breakpoints.down("md")]: {
    marginBottom: 0
  }
});
const ForgotPasswordLink = (theme) => ({
  ...typography["Lato Emphasized 1"],
  color: theme.palette.highlight2[900],
  fontSize: "16px",
  lineHeight: "22px",
  fontWeight: 700,
  letterSpacing: "0.5px",
  paragraphSpacing: "16px",
  verticalAlign: "middle",
  textAlign: "right",
  margin: "0.5rem 0.5rem 2rem",
  cursor: "pointer",
  a: {
    color: theme.palette.highlight2[900],
    textDecoration: "none"
  },
  "&:hover": {
    textDecoration: "underline"
  }
});
const LoginButton = (theme) => ({
  ...typography["Lato Emphasized 1"],
  color: theme.palette.common.white,
  fontSize: "16px",
  lineHeight: "22px",
  fontWeight: 500,
  letterSpacing: "0.5px",
  paragraphSpacing: "16px",
  verticalAlign: "middle",
  height: "56px",
  "&.MuiButton-root": {
    backgroundColor: theme.palette.primary.main,
    "&:hover": {
      backgroundColor: theme.palette.primary.dark
    },
    "&.Mui-disabled": {
      color: theme.palette.common.white,
      "&:hover": {
        cursor: "not-allowed"
      }
    }
  },
  [theme.breakpoints.down("md")]: {
    height: "48px"
  }
});
const StyledDivider = (theme) => ({
  ...typography["Lato Body 1"],
  fontSize: "16px",
  lineHeight: "24px",
  fontWeight: 400,
  paragraphSpacing: "16px",
  letterSpacing: "0.25px",
  color: theme.palette.grey[700],
  margin: "1.5rem 0",
  "&.MuiDivider-root": {
    borderColor: theme.palette.primary[75],
    "&::before, &::after": {
      borderColor: theme.palette.primary[75]
    }
  }
});
const GoogleButton = (theme) => ({
  ...typography["Lato Emphasized 1"],
  fontSize: "16px",
  lineHeight: "22px",
  fontWeight: 500,
  letterSpacing: "0.5px",
  paragraphSpacing: "16px",
  verticalAlign: "middle",
  marginBottom: "1rem",
  height: "56px",
  "&.MuiButton-root": {
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.grey[800],
    "&:hover": {
      backgroundColor: theme.palette.grey[100]
    }
  },
  "& .MuiButton-startIcon": {
    marginRight: "0.5rem"
  },
  [theme.breakpoints.down("md")]: {
    height: "48px"
  }
});
const RegisterLink = (theme) => ({
  ...typography["Lato Body 1"],
  color: theme.palette.primary.main,
  fontSize: "16px",
  lineHeight: "22px",
  fontWeight: 400,
  letterSpacing: "0.5px",
  paragraphSpacing: "16px",
  verticalAlign: "middle",
  marginTop: "2rem",
  marginBottom: "4.5rem",
  textAlign: "center",
  "& a": {
    textDecoration: "none",
    cursor: "pointer",
    marginLeft: "0.25rem",
    fontWeight: 700,
    "&:hover": {
      textDecoration: "underline"
    }
  }
});
const SupportLink = (theme) => ({
  ...typography["Lato Body 1"],
  color: theme.palette.grey[800],
  fontSize: "16px",
  lineHeight: "22px",
  fontWeight: 400,
  letterSpacing: "0.5px",
  paragraphSpacing: "16px",
  verticalAlign: "middle",
  marginTop: "2rem",
  textAlign: "center",
  textDecoration: "underline",
  "& a": {
    color: theme.palette.grey[800]
  }
});
export {
  Description,
  ForgotPasswordLink,
  FormContainer,
  GoogleButton,
  LoginButton,
  Logo,
  LogoContainer,
  LogoText,
  RegisterLink,
  StyledDivider,
  StyledTextField,
  SupportLink,
  Title
};
